// src/components/Layout.tsx
import React, { ReactNode, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(() => {
    const saved = localStorage.getItem("isDarkMode");
    return saved === "true";
  });

  const location = useLocation();
  const navigate = useNavigate();
  const isLoginPage = location.pathname === "/";

  useEffect(() => {
    const html = document.documentElement;
    if (isDarkMode) {
      html.classList.add("dark");
    } else {
      html.classList.remove("dark");
    }
    localStorage.setItem("isDarkMode", String(isDarkMode));
  }, [isDarkMode]);

  return (
    <>
      {/* هدر ثابت در بالای صفحه - از جریان سند خارج شده */}
      <div
        className="pageHeader"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: "70px",                    // ارتفاع ثابت
          background: "var(--app-card-bg-color)",
          borderBottom: "1px solid var(--app-border-color)",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
        }}
      >
        <i className="logo-icon ap ap-aptask" style={{ fontSize: "28px" }} />

        {/* دکمه بازگشت */}
        {!isLoginPage && (
          <button
            onClick={() => navigate(-1)}
            className="back-btn"
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "var(--app-card-bg-color)",
              color: "var(--app-text-color)",
              border: "1px solid var(--app-border-color)",
              borderRadius: "8px",
              padding: "8px 12px",
              cursor: "pointer",
              fontSize: "18px",
              transition: "all 0.2s var(--app-transition)",
            }}
            title="بازگشت"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
        )}

        {/* دکمه تم */}
        <button
          onClick={() => setIsDarkMode(prev => !prev)}
          style={{
            position: "absolute",
            right: "12px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "var(--app-card-bg-color)",
            color: "var(--app-text-color)",
            border: "1px solid var(--app-border-color)",
            borderRadius: "8px",
            padding: "8px 12px",
            cursor: "pointer",
            fontSize: "18px",
          }}
          title={isDarkMode ? "حالت روشن" : "حالت تاریک"}
        >
          {isDarkMode ? "🌙" : "☀️"}
        </button>
      </div>

      {/* محتوای اصلی - دقیقاً زیر هدر شروع می‌شود */}
      <div
        className="apGlobal"
        style={{
          paddingTop: "70px",        // دقیقاً برابر با height هدر
          minHeight: "calc(100vh - 70px)", // صفحه همیشه پر باشد (اختیاری)
          background: "var(--app-bg-color)",
        }}
      >
        <main style={{ width: "100%" }}>
          {children}
        </main>
      </div>
    </>
  );
}